module.exports = __webpack_public_path__ + "img/img01.0d544141.png";